// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M15.85 2.87A4 4 0 0 0 18 1.32c-.91-.33-1.9-.4-2.85-.19-.87.27-1.62.81-2.15 1.55.91.33 1.9.4 2.85.19M20 20H6v-1h14zM4 16h13v1H4zm5.26-7.27c0-.8-.3-1.58-.82-2.18q.3-.31.67-.55.77.4 1.39 1a1 1 0 0 0 1.35 0q.6-.6 1.38-1a3.8 3.8 0 1 1-4.17 6.35q-.62-.4-1.06-1a3.3 3.3 0 0 0 1.26-2.62M21 17h-2v-2a1 1 0 0 0-1-1h-3.69A6 6 0 0 0 14 3.8a1.6 1.6 0 0 0-.77-.2 3.5 3.5 0 0 0-1.91.82L12 1H9.94l.72 3.4a3.5 3.5 0 0 0-1.89-.8q-.4 0-.77.2a6 6 0 0 0-2.08 2 1 1 0 0 0 .34 1.4A1.49 1.49 0 0 1 6 9.9a1 1 0 0 0-.59 1.28A6 6 0 0 0 7.69 14H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1"
    />
  </BaseIcon>
)
